export const ctwrInfo = {
    route: '/CTWR',
    title: 'CTWR',
    subtitle: 'Casting Tooling Work Request',
    description: 'Create and manage Work Requests.',
    adminDescription: 'Manage roles, workflows, etc.',
    image: 'image-ctwr',
    version: '1.13.50',
    revisionDate: '2018-12-13 17:27:56',
    trainingUrl: 'https://gmweb.gm.com/sites/me_cetc_mfg_design/Cast%20Tooling%20TIS/Forms/AllItems.aspx',
    legacyUrl: {
        //PCF
        'LOCAL': 'https://mesc-ui-dev.cp-epg2i.gm.com/legacy/',
        'TEST': 'https://mfg-gateway-test.gm.com/ctwr/legacy/',
        'PROD': 'https://mfg-gateway.gm.com/ctwr/legacy/',

        //OCF
        //'DEV': 'https://ctwr-ui-legacy-dev.apps.pcfepgstg1mi.gm.com/legacy/',
        'DEV': 'https://ctwr-legacy-dev.musea2.azure.ext.gm.com',
        'QA': 'https://mfg-gateway-qa.gm.com/ctwr/legacy',

    }
}
const devProdCGPAppId = '7F010BC0-B9D3-4B66-9E95-B07A17196072';
const preProdCGPAppId = '4F0A0DEA-CC56-4886-8C77-4B07FF97A16F';
const ProdCGPAppId = '4F0A0DEA-CC56-4886-8C77-4B07FF97A16F';
